/**
 * Directives for module mwApp
 */

/**
 * env directive <br>
 * checks runtime application flags and environment variables
 *
 * @class env
 * @memberof mwApp
 * @see mwApp
 *
 * @ngdoc directive
 * @name mwApp.directive:env
 *
 * @example
 * <div env="APP_YM_ENABLED">...</div>
 */
/* @ngInject */
export function env () {
  const cache = Object.create(null)
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      const attr = attrs.env
      if (attr) {
        if (cache[attr] === undefined) {
          cache[attr] = scope.$eval(attr, window.ENV)
        }
        if (!cache[attr]) {
          element.addClass('hidden') // removing not always working, for example inside ngRepeat...
          element.remove()
        }
      }
    }
  }
}
